document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const overlay = document.querySelector('[data-site-overlay]');
  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', e => {
    e.preventDefault(); body.classList.add('drawer-open');
  }));
  document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', () => body.classList.remove('drawer-open')));
  if(overlay) overlay.addEventListener('click', () => body.classList.remove('drawer-open'));

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting && entry.target.classList.add('visible'));
  }, {threshold:.12});
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  document.querySelectorAll('[data-gallery-thumb]').forEach(btn => btn.addEventListener('click', () => {
    const main = document.querySelector('[data-gallery-main]');
    if(main && btn.dataset.src){ main.src = btn.dataset.src; main.srcset = ''; }
  }));

  const panel = document.querySelector('[data-product-panel]');
  const sticky = document.querySelector('[data-sticky-add]');
  if(panel && sticky){
    const io = new IntersectionObserver(([e]) => sticky.classList.toggle('show', !e.isIntersecting), {threshold:0});
    io.observe(panel);
  }
});


/* V5.4.6 — interactions fiche produit et panier */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (!main || !thumb.dataset.src) return;
      main.src = thumb.dataset.src;
      main.srcset = '';
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });
    });
  });

  document.querySelectorAll('[data-quantity]').forEach(function (control) {
    var input = control.querySelector('[data-cart-quantity-input], input[type="number"]');
    if (!input) return;
    var valueDisplay = control.querySelector('[data-quantity-value]');
    var minimum = parseInt(input.getAttribute('min') || '0', 10);
    var minus = control.querySelector('[data-quantity-minus]');
    var plus = control.querySelector('[data-quantity-plus]');

    function setQuantity(nextValue) {
      var value = Math.max(minimum, parseInt(nextValue || minimum, 10));
      input.value = value;
      if (valueDisplay) valueDisplay.textContent = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (minus) minus.addEventListener('click', function () {
      setQuantity(parseInt(input.value || minimum, 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      setQuantity(parseInt(input.value || minimum, 10) + 1);
    });
  });

  var variantSelect = document.querySelector('[data-variant-select]');
  var productPrice = document.querySelector('[data-product-price]');
  if (variantSelect && productPrice) {
    variantSelect.addEventListener('change', function () {
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (option && option.dataset.price) productPrice.textContent = option.dataset.price;
    });
  }
});

/* V5.4.7 — mise à jour automatique et fiable du panier Shopify */
(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function setBusy(form, busy) {
    if (!form) return;
    form.classList.toggle('is-updating', busy);
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    form.querySelectorAll('[data-quantity-minus], [data-quantity-plus], [data-cart-quantity-input], .acv-checkout-btn')
      .forEach(function (element) { element.disabled = busy; });
  }

  function updateVisibleCart(cart) {
    var subtotal = document.querySelector('[data-cart-subtotal]');
    var total = document.querySelector('[data-cart-total]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (total) total.textContent = formatMoney(cart.total_price);

    var headerCount = document.querySelector('.acv-cart-header > p');
    if (headerCount) {
      headerCount.textContent = cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '');
    }
  }

  async function changeCartLine(input) {
    var form = input.closest('.acv-cart-form');
    var line = parseInt(input.dataset.line || '0', 10);
    var quantity = Math.max(0, parseInt(input.value || '0', 10));
    if (!line) return;

    input.value = quantity;
    setBusy(form, true);

    try {
      var response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ line: line, quantity: quantity })
      });

      if (!response.ok) throw new Error('La mise à jour du panier a échoué.');
      var cart = await response.json();
      updateVisibleCart(cart);

      /* Le rechargement garantit que prix de ligne, remises, seuil de livraison,
         compteur d'en-tête et suppression à quantité zéro restent synchronisés
         avec le calcul officiel de Shopify. */
      window.location.reload();
    } catch (error) {
      setBusy(form, false);
      window.alert('Le panier n’a pas pu être mis à jour. Merci de réessayer.');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cartForm = document.querySelector('.acv-cart-form');
    if (!cartForm) return;

    var timers = new WeakMap();
    cartForm.querySelectorAll('[data-cart-quantity-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(timers.get(input));
        timers.set(input, setTimeout(function () { changeCartLine(input); }, 180));
      });
    });
  });
})();

/* V5.5.5 — sélection de collection et tri natif Shopify */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-collection-selector]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.value) window.location.href = select.value;
    });
  });

  document.querySelectorAll('[data-sort-selector]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });
});


/* V5.5.6 — filtre instantané par nom sur les collections */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-name-search]').forEach(function (input) {
    var scope = input.closest('.page-width');
    if (!scope) return;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-product-card]'));
    var status = scope.querySelector('[data-product-search-status]');
    var clear = scope.querySelector('[data-product-search-clear]');
    function normalize(value) {
      return (value || '').toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }
    function filterProducts() {
      var query = normalize(input.value);
      var visible = 0;
      cards.forEach(function (card) {
        var matches = !query || normalize(card.dataset.productTitle).indexOf(query) !== -1;
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (status) status.textContent = query ? visible + ' produit' + (visible > 1 ? 's' : '') + ' trouvé' + (visible > 1 ? 's' : '') : '';
    }
    input.addEventListener('input', filterProducts);
    if (clear) clear.addEventListener('click', function () { input.value = ''; filterProducts(); input.focus(); });
  });
});


/* V5.6.0 — menu mobile des collections */
document.addEventListener('DOMContentLoaded', function () {
  var body = document.body;
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var navigation = document.getElementById('MobileCollectionsMenu');
  var overlay = document.querySelector('[data-site-overlay]');
  if (!toggle || !navigation) return;

  function setMenu(open) {
    body.classList.toggle('mobile-menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Fermer le menu des collections' : 'Ouvrir le menu des collections');
    navigation.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  toggle.addEventListener('click', function () {
    setMenu(!body.classList.contains('mobile-menu-open'));
  });

  navigation.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () { setMenu(false); });
  });

  if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') setMenu(false); });
  window.addEventListener('resize', function () { if (window.innerWidth > 1100) setMenu(false); });
});
